import React from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import {
  submitEntityForm,
  submitBusinessInfoForm,
  businessData,
  submitBankInfoForm,
  submitBusinessDocumentForm,
  goToStep,
} from 'actions/kyb';
import {
  bankList,
  businessOpeningChoices,
  newBusinessInfoRequest,
} from 'actions';
import * as clevertapKyb from 'clevertap/kyb';
import withFeatureFlags from 'hocs/withFeatureFlags';
import BusinessEntityForm from './BusinessEntityForm';
import styles from './style.css';
import BusinessInfoForm from './BusinessInfoForm';
import Progress from './Progress';
import DocumentUpload from './DocumentUpload';
import BankInfo from './BankInfo';
import PreviewKyb from './PreviewKyb';
import Welcome from '../Welcome/Welcome';
import AllSet from './AllSet/AllSet';

class Kyb extends React.Component {
  constructor(props) {
    super(props);
    const { business } = this.props.data.moka.user;
    const businessId = business.id;
    this.state = {
      businessId,
      businessEntity: '',
    };
  }

  componentDidMount() {
    const { business } = this.props.data.moka.user;
    if (business.is_kyb_registration_completed) {
      browserHistory.push('/dashboard');
    } else {
      const {
        phone,
        email,
        business: {
          business_category_id: businessCategory,
          province: businessLocation,
        },
      } = this.props.data.moka.user;
      clevertapKyb.clevertapTracker('KYB Start', {
        email,
        phone,
        businessCategory,
        businessLocation,
      });
      this.props.dispatch(businessData({ businessId: this.state.businessId }));
      this.props.dispatch(bankList());
      this.props.dispatch(businessOpeningChoices());
      this.props.dispatch(newBusinessInfoRequest());
    }
  }

  appendBusinessOpeningClevertap = clevertapData => {
    const {
      businessOpeningChoices,
      businessInfo: { business_opening },
    } = this.props.data.moka;

    const businessOpeningName =
      business_opening !== null
        ? businessOpeningChoices.find(bo => bo.code === business_opening).name
        : null;
    if (businessOpeningName !== null)
      clevertapData['Business Opening'] = businessOpeningName;
  };

  gotoKYB = () => {
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;

    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
    };
    this.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker('KYB Activate Mobile Payment', clevertapData);
    this.props.dispatch(goToStep(1));
  };

  handleBusinessEntitySubmit = values => {
    this.props.dispatch(
      submitEntityForm({
        business_entity_type: values.businessEntity,
        businessId: this.state.businessId,
        editMode: this.props.data.kybForm.editMode,
      })
    );
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    this.setState({
      businessEntity: values.businessEntity,
    });
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntity: values.businessEntity,
    };
    this.appendBusinessOpeningClevertap(clevertapData);
    if (values.businessEntity === 'personal') {
      clevertapKyb.clevertapTracker(
        'KYB Business Type Personal Created',
        clevertapData
      );
    } else {
      clevertapKyb.clevertapTracker(
        'KYB Business Type Corporate Created',
        clevertapData
      );
    }
  };

  handleBusinessInfoSubmit = ({
    city,
    address,
    kecamatan,
    name,
    province,
    zipcode,
  }) => {
    const values = {
      city,
      kecamatan,
      province,
      postal_code: zipcode,
      name: name.trim(),
      address: address.trim(),
    };
    this.props.dispatch(
      submitBusinessInfoForm({
        values,
        businessId: this.state.businessId,
        editMode: this.props.data.kybForm.editMode,
      })
    );
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
    } = this.props.data.kybForm.kybData;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      businessName: name,
      businessAddress: address,
      province,
      city,
      kecamatan,
      postal_code: zipcode,
    };
    this.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker(
      'KYB Business Information Created',
      clevertapData
    );
  };

  handleDocumentUploadSubmit = values => {
    this.props.dispatch(
      submitBusinessDocumentForm({
        KTP_NUMBER: values.id.trim(),
        KTP_NAME: values.name.trim(),
        IMAGE_URL: this.props.data.kybForm.idCard,
        businessId: this.state.businessId,
        editMode: this.props.data.kybForm.editMode,
      })
    );
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
      address,
      city,
      kecamatan,
      name: businessName,
      province,
      postal_code: postalCode,
    } = this.props.data.kybForm.kybData;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      address,
      city,
      kecamatan,
      businessName,
      province,
      postalCode,
      isKTPPhotoUploaded: true,
      NameOnID: values.name.trim(),
      IDNumber: values.id.trim(),
    };
    this.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker('KYB KTP Information Created', clevertapData);
  };

  handleBankInfoSubmit = values => {
    const { kybBankData, editMode } = this.props.data.kybForm;
    this.props.dispatch(
      submitBankInfoForm({
        values,
        businessId: this.state.businessId,
        editMode,
        kybBankData,
        multipleBankAccountV2: this.props.multipleBankAccountV2,
      })
    );
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
      address,
      city,
      kecamatan,
      name: businessName,
      province,
      postal_code: postalCode,
    } = this.props.data.kybForm.kybData;
    const {
      KTP_NAME: NameOnID,
      KTP_NUMBER: IDNumber,
    } = this.props.data.kybForm.kybIdentity;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      address,
      city,
      kecamatan,
      businessName,
      province,
      postalCode,
      isKTPPhotoUploaded: true,
      NameOnID,
      IDNumber,
      bankName: values.bankName,
      bankAccountName: values.name,
      bankAcountNumber: values.accountNumber,
    };
    this.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker(
      'KYB Bank Account Information Created',
      clevertapData
    );
  };

  componentWillUnmount() {
    this.props.dispatch(goToStep(0));
  }

  render() {
    const { dispatch, data, kybNewContent } = this.props;
    const { step } = data.kybForm;
    const {
      error,
      businessProvinceState,
      businessCityState,
      businessZipcodeState,
      businessKecamatanState,
      bankListState,
    } = data.moka;
    return (
      <div className={`${styles['entity-type']}`}>
        <div className={`${styles.box} row ${styles['row-center']}`}>
          {step === 0 && (
            <Welcome onClickActivateMobilePayments={this.gotoKYB} />
          )}
          <Progress step={step} businessEntity={this.state.businessEntity} />
          {step === 1 && (
            <BusinessEntityForm
              dispatch={dispatch}
              history={this.props.history}
              onSubmit={this.handleBusinessEntitySubmit}
              error={error}
              appendBusinessOpeningClevertap={
                this.appendBusinessOpeningClevertap
              }
            />
          )}
          {step === 2 && (
            <BusinessInfoForm
              dispatch={dispatch}
              history={this.props.history}
              onSubmit={this.handleBusinessInfoSubmit}
              businessProvinceState={businessProvinceState}
              businessCityState={businessCityState}
              businessZipcodeState={businessZipcodeState}
              businessKecamatanState={businessKecamatanState}
              error={error}
              appendBusinessOpeningClevertap={
                this.appendBusinessOpeningClevertap
              }
            />
          )}
          {step === 3 && (
            <DocumentUpload
              dispatch={dispatch}
              history={this.props.history}
              onSubmit={this.handleDocumentUploadSubmit}
              error={error}
              appendBusinessOpeningClevertap={
                this.appendBusinessOpeningClevertap
              }
            />
          )}
          {step === 4 && (
            <BankInfo
              dispatch={dispatch}
              history={this.props.history}
              onSubmit={this.handleBankInfoSubmit}
              bankListState={bankListState}
              error={error}
              appendBusinessOpeningClevertap={
                this.appendBusinessOpeningClevertap
              }
            />
          )}
          {step === 5 && (
            <PreviewKyb
              dispatch={dispatch}
              history={this.props.history}
              bankListState={bankListState}
              error={error}
              appendBusinessOpeningClevertap={
                this.appendBusinessOpeningClevertap
              }
            />
          )}
          {step === 6 && <AllSet />}
          {!kybNewContent && step !== 0 && step !== 5 && step !== 6 && (
            <div className={`row ${styles.skip}`}>
              <div className="col-md-12">
                <Link className={`${styles['skip-btn']}`} to="/dashboard">
                  Skip this step{' '}
                  <i className="fa fa-angle-right" aria-hidden="true" />
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    data: state,
  };
}

function mapFeatureFlags(flags) {
  return {
    multipleBankAccountV2: flags.multipleBankAccountV2,
    kybNewContent: flags.kybNewContent,
  };
}

export default withFeatureFlags(mapFeatureFlags)(connect(select)(Kyb));
